export default __webpack_public_path__ + "static/media/13.4d5df0b2.jpg";